/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

const input = require('b_').with('input');

export const TextArea = ({
    id,
    required,
    disabled,
    error,
    mod,
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    readOnly,
    rows,
}) => (
    <textarea
        id={id}
        required={required}
        disabled={disabled}
        className={input({ error: !!error, ...mod })}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
        rows={rows}
    />
);
